export default __webpack_public_path__ + "static/media/pnsv_stand_pilot.fbc64e6d.png";